import { render, staticRenderFns } from "./ProcessingRequestModal.vue?vue&type=template&id=0f1972e4&scoped=true"
import script from "./ProcessingRequestModal.vue?vue&type=script&lang=js"
export * from "./ProcessingRequestModal.vue?vue&type=script&lang=js"
import style0 from "./ProcessingRequestModal.vue?vue&type=style&index=0&id=0f1972e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1972e4",
  null
  
)

export default component.exports